import { Button } from "components/DesignSystem/Button/Button";
import { SmallArrowUpRight } from "components/icons/SmallArrowUpRight";
import { TaxFiling } from "store/apis/filing";
import { FILED, SUBSCRIBED } from "constants/filing";
import ConditionalToolTip from "components/design/conditionalToolTip";
import { useStartFilingSubscription } from "./useStartFilingSubscription";

type FilingRowActionProps = {
  filing: TaxFiling;
  onViewStatus: (taskId: string) => void;
  onViewCart: () => void;
};

export const FilingRowAction = ({
  filing,
  onViewStatus,
  onViewCart,
}: FilingRowActionProps) => {
  const { isAddingToCart, startSubscriptionCheckout } =
    useStartFilingSubscription(filing.payment_schedule, filing.state, {
      filingId: filing.uuid,
      startDate: filing.filing_period_start_date,
      endDate: filing.filing_period_end_date,
    });

  if (filing.status === FILED && !filing.task) {
    return null;
  }

  if (filing.task) {
    return (
      <Button
        customType="secondary"
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onViewStatus(filing.task!.task_id);
        }}
      >
        View status
      </Button>
    );
  }

  if (filing.is_in_cart) {
    return (
      <Button
        customType="secondary"
        size="small"
        rightIcon={<SmallArrowUpRight />}
        onClick={(e) => {
          e.stopPropagation();
          onViewCart();
        }}
      >
        Go to cart
      </Button>
    );
  }

  if (filing.status === SUBSCRIBED) {
    return (
      <ConditionalToolTip condition="This filing will start automatically once the subscription is billed.">
        <span>
          <Button customType="primary" size="small" disabled>
            Start filing
          </Button>
        </span>
      </ConditionalToolTip>
    );
  }

  return (
    <Button
      customType="primary"
      size="small"
      isLoading={isAddingToCart}
      disabled={isAddingToCart}
      onClick={(e) => {
        e.stopPropagation();
        void startSubscriptionCheckout();
      }}
    >
      Start filing
    </Button>
  );
};
